import React from "react";

import {
  CardSidebar,
  Block,
  TitleSidebar,
  TitlePost,
  Date,
  CatList,
  CatListItem,
} from "../../components/Blog/Sidebar";
import { convertDateToText } from "../../lib/dateHelper";

import InputSearch from "../../components/Blog/InputSearch";

const Sidebar = ({ data }) => {
  return (
    <>
      <CardSidebar p="15px" pl="20px">
        <form>
          <InputSearch />
        </form>
      </CardSidebar>
      <CardSidebar>
        <TitleSidebar>Recent Posts</TitleSidebar>

        {data.map(({ node }) => (
          <Block>
            <TitlePost link={node.slug}>{node.title}</TitlePost>
            <Date>{convertDateToText(node.date)}</Date>
          </Block>
        ))}
      </CardSidebar>
      <CardSidebar>
        <TitleSidebar>Popular Posts</TitleSidebar>
        {data.map(({ node }) => (
          <Block>
            <TitlePost link={node.slug}>{node.title}</TitlePost>
            <Date>{convertDateToText(node.date)}</Date>
          </Block>
        ))}
      </CardSidebar>
      <CardSidebar>
        <TitleSidebar mb="28px">Categories</TitleSidebar>
        <CatList>
          <CatListItem post={30}>Facebook Ads</CatListItem>
          <CatListItem post={20}>Shopify</CatListItem>
          <CatListItem post={16}>Dropshipping</CatListItem>
          <CatListItem post={11}>Mark News</CatListItem>
        </CatList>
      </CardSidebar>
    </>
  );
};
export default Sidebar;
